var path = '/pages/guestlists/views/pages/guestlists/list.tpl.html';
var html = "<listview store=\"vm.store\" ng-if=\"vm.currentView === 'list'\"></listview>\n<div ng-if=\"vm.currentView === 'grid'\">\n    <div class=\"heading-toolset-wrapper\">\n        <h1>Guestlists</h1>\n    </div>\n    <al-guestlists-grid-view on-switch-to-list-view=\"vm.changeView('list')\"></al-guestlists-grid-view>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/guestlists/views/pages/guestlists/list.tpl.html
// module id = 2259
// module chunks = 1